import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { DeleteEntityTemplateDialogProps } from "./DeleteEntityTemplateDialog.tsx";
import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "../../common/api/apiShared.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useDeleteEntityTemplateDialog(props: DeleteEntityTemplateDialogProps) {
    const snackBar = useDotLegalSnackbar();

    const deleteEntityTemplate = async () => {
        return await deleteHttp(`/entity-templates/${props.entityTemplateId}`);
    };

    const deleteMutation = useDotLegalMutation(deleteEntityTemplate, {
        onSuccess: (result: any) => {
            const deleteResponse = result.value();
            if (deleteResponse.isDeleted) {
                snackBar.show(createElement(Trans, { i18nKey: "itemDeletedSuccess", values: { name: props.entityTemplateName } }));
                props.onDeleteSuccess();
            } else {
                snackBar.show(createElement(Trans, { i18nKey: "cantDeleteEntityTemplate", values: { name: props.entityTemplateName } }), "warning");
                props.onCloseDialog();
            }
        },
    });

    const onDelete = () => {
        deleteMutation.mutate();
    };

    return {
        isDeleting: deleteMutation.isLoading,
        onDelete,
    };
}
